var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgListings = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54326 0.503145L4.64389 6.87631C4.21412 7.56813 4.71726 8.4696 5.53487 8.4696H13.3231C14.1407 8.4696 14.6439 7.56813 14.2141 6.87631L10.3252 0.503145C9.91643 -0.167715 8.95206 -0.167715 8.54326 0.503145Z",
    fill: "#6D675F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1994 19.9999C17.8045 19.9999 19.9164 17.888 19.9164 15.2829C19.9164 12.6778 17.8045 10.5659 15.1994 10.5659C12.5943 10.5659 10.4824 12.6778 10.4824 15.2829C10.4824 17.888 12.5943 19.9999 15.1994 19.9999Z",
    fill: "#6D675F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04822 19.4758H7.33753C7.91405 19.4758 8.38574 19.0041 8.38574 18.4276V12.1383C8.38574 11.5618 7.91405 11.0901 7.33753 11.0901H1.04822C0.471698 11.0901 0 11.5618 0 12.1383V18.4276C0 19.0041 0.471698 19.4758 1.04822 19.4758Z",
    fill: "#6D675F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgListings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/listings.0d26a32a.svg";
export { ForwardRef as ReactComponent };